import errorInterceptor from '../api/errorInterceptor';
import globalErrorHandler from './globalErrorHandler';
import { ErrorResponse } from '../types/error';
import Logger from './logger';

export class ErrorHandlingSetup {
  private static instance: ErrorHandlingSetup;
  private isInitialized = false;

  private constructor() {}

  static getInstance(): ErrorHandlingSetup {
    if (!ErrorHandlingSetup.instance) {
      ErrorHandlingSetup.instance = new ErrorHandlingSetup();
    }
    return ErrorHandlingSetup.instance;
  }

  initialize() {
    if (this.isInitialized) {
      Logger.warn('Error handling setup', 'Error handling already initialized');
      return;
    }

    Logger.info('Error handling setup', 'Initializing error handling system...');

    globalErrorHandler.init((error: Error, context?: any) => {
      Logger.error(
        'Global error caught',
        error.message,
        {
          component: 'ErrorHandlingSetup',
          action: 'globalError',
        },
        error,
        context
      );
    });

    errorInterceptor.setErrorHandler((errorResponse: ErrorResponse) => {
      this.handleApiError(errorResponse);
    });

    errorInterceptor.setValidationErrorHandler((errors: any[]) => {
      this.handleValidationErrors(errors);
    });

    this.isInitialized = true;
    Logger.info('Error handling setup', 'Error handling system initialized successfully');
  }

  private handleApiError(errorResponse: ErrorResponse) {
    Logger.info(
      'API error handled',
      errorResponse.message || errorResponse.error,
      {
        component: 'ErrorHandlingSetup',
        action: 'handleApiError',
        path: errorResponse.path,
      },
      {
        status: errorResponse.status,
        error: errorResponse.error,
      }
    );
  }

  private handleValidationErrors(errors: any[]) {
    Logger.warn(
      'Validation errors handled',
      `Found ${errors.length} validation error(s)`,
      {
        component: 'ErrorHandlingSetup',
        action: 'handleValidationErrors',
      },
      {
        errorCount: errors.length,
        errors: errors,
      }
    );
  }

  isReady(): boolean {
    return this.isInitialized;
  }

  getErrorInterceptor() {
    return errorInterceptor;
  }

  getGlobalErrorHandler() {
    return globalErrorHandler;
  }
}

const errorHandlingSetup = ErrorHandlingSetup.getInstance();

export default errorHandlingSetup;
